// src/redux/thunks/cancelTestFromDb.js (or wherever you keep thunks)

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";
export const cancelTestFromDb = createAsyncThunk(
  "appointments/cancelTestFromDb",
  async ({ appointmentId, testId, reason }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/appointments/${appointmentId}/tests/${testId}`,
        {
          data: { reason },
        },
      );

      return { appointmentId, testId, message: response.data?.message };
    } catch (error) {
      console.error("❌ Failed to cancel test from DB:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to cancel test",
      );
    }
  },
);
